import { render, staticRenderFns } from "./pressurerecord.vue?vue&type=template&id=cf9cd054&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pressurerecord.vue"
export default component.exports